import { render, staticRenderFns } from "./pop-stat2.vue?vue&type=template&id=5058df33&scoped=true&"
import script from "./pop-stat2.vue?vue&type=script&lang=js&"
export * from "./pop-stat2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058df33",
  null
  
)

export default component.exports